module.exports = __webpack_public_path__ + "static/img/banner03.da95617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner03.png
// module id = 38un
// module chunks = 1